import { render, staticRenderFns } from "./SpaceSettings.vue?vue&type=template&id=a7e2ed60&scoped=true&"
import script from "./SpaceSettings.vue?vue&type=script&lang=js&"
export * from "./SpaceSettings.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSettings.vue?vue&type=style&index=0&id=a7e2ed60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e2ed60",
  null
  
)

export default component.exports